export default __webpack_public_path__ + "dfcb0533cfd5d97fec9dc3806137d816.svg";